// Cash Transactions Mutations

export const setCashTransactionList = (state, payload) => {
  state.transactionsList = payload
}

export const setCashTransactionInfo = (state, payload) => {
  state.transactionInfo = payload
}

export const setCashList = (state, payload) => {
  state.cashList = payload
}
